import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AddNew from "./AddNew";
import Rename from "./Rename";
import Delete from "./Delete";
import apis from "../services";
import DEX from "./DEX";
function Favorites() {
  const userId = localStorage.getItem("userId");
  const [watchlists, setWatchlists] = useState([]);
  const [newWatchlistName, setNewWatchlistName] = useState("");
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [selectedWatchlistId, setSelectedWatchlistId] = useState(null);
  const handleDropdownToggle = () => {
    setIsDropdownOpen(!isDropdownOpen);
  };
  useEffect(() => {
    // const fetchWatchlists = async () => {
    //   try {
    //     const response = await apis.watchnew();
    //     if (response.success) {
    //       const userWatchlists = response.data.filter((list) => list.userId === userId);
    //       setWatchlists(userWatchlists);
    //     } else {
    //       console.error("Failed to fetch watchlists:", response.message);
    //     }
    //   } catch (error) {
    //     console.error("Error fetching watchlists:", error);
    //   }
    // };
   
  }, [userId]);
  const handleCreateWatchlist = async () => {
    if (newWatchlistName.trim() === "") {
      alert("Please enter a valid watchlist name.");
      return;
    }
    if (!userId) {
      alert("User ID is missing. Please log in again.");
      return;
    }
    const body = { Name: newWatchlistName, userId };
    try {
      const newWatchlist = await apis.createwatch(body);
      if (newWatchlist.success) {
        setNewWatchlistName(""); // Clear input
        // Fetch updated watchlists
        const response = await apis.watchnew();
        if (response.success) {
          const userWatchlists = response.data.filter((list) => list.userId === userId);
          setWatchlists(userWatchlists);
        } else {
          console.error("Failed to fetch updated watchlists:", response.message);
        }
      } else {
        console.error("Failed to create watchlist:", newWatchlist.message);
      }
    } catch (error) {
      console.error("Error creating watchlist:", error);
    }
  };
  const handleRenameWatchlist = async () => {
    if (!selectedWatchlistId || newWatchlistName.trim() === "") {
      alert("Please select a watchlist and enter a valid name.");
      return;
    }
    const body = { Name: newWatchlistName, userId, watchlistId: selectedWatchlistId };
    try {
      const response = await apis.renamewatchlist(body);
      if (response.success) {
        setNewWatchlistName("");
   

      
        const updatedWatchlists = await apis.watchnew();
        setWatchlists(updatedWatchlists.data);
      } else {
        console.error("Failed to rename watchlist:", response.message);
      }
    } catch (error) {
      console.error("Error renaming watchlist:", error);
    }
  };

  return (
    <div className="invest-background">
      {/* Header */}
      <div className="header-container">
        <div className="header-content">
          <h1 className="header-title">
            <Link to="/home" style={{ textDecoration: "none", color: "inherit" }}>
              My Watchlist
            </Link>
          </h1>
        </div>
        {/* /////////////////////////////////////////////////////////////////////// */}
        <div className="watch-list-container">
          <div className="watch-list-tabs">
            <div className="watch-list-new-tab">
              {/* {watchlists.length > 0 ? (
                <>
                  {watchlists.slice(0, 5).map((watchlist) => (
                    <div key={watchlist._id} className="watch-list-options">
                      <h3>{watchlist.Name}</h3>
                    </div>
                  ))}
                  {watchlists.length > 5 && (
                    <div className="dropdown">
                      <button
                        onClick={handleDropdownToggle}
                        className="dropdown-toggle"
                      >
                        {isDropdownOpen ? "Hide Watchlists" : "Show More"}
                      </button>
                      {isDropdownOpen && (
                        <div className="dropdown-menu">
                          {watchlists.slice(5).map((watchlist) => (
                            <div
                              key={watchlist._id}
                              className="watch-list-options dropdown-item"
                            >
                              <h3>{watchlist.Name}</h3>
                            </div>
                          ))}
                        </div>
                      )}
                      
                    </div>
                
                  )}
                </>
              ) :
                (
                  <p>No watchlists available</p>
                )} */}
                        {/* <p>DEX</p>
            <p>Private Sale</p>
            <p>CEX</p> */}
            </div>
    

          </div>
        </div>
      </div>
              {/* import dex page */}
                    <div>
                    <DEX/>
                    </div>
    </div>
  );
}

export default Favorites;
